<template>
  <div>
    <v-sheet color="primary" class="d-flex align-center" height="44px">
      <v-container class="d-flex justify-center py-0">
        <v-btn
          text
          v-if="informationsContacts.emergency_tel"
          :href="getTelLinkFromPhone(informationsContacts.emergency_tel)"
          depressed
          rounded
          class="
            white--text
            text-body-1 text-none
            font-weight-bold
            px-md-7 px-lg-8
          "
        >
          <img
            src="../../assets/img/emergency-icon.svg"
            class="d-block filter-white"
            height="24px"
          />
          <span class="ml-2">Emergência</span>
        </v-btn>

        <!-- <v-btn
            color="white"
            v-if="informationsContacts.ombudsman"
            :href="informationsContacts.ombudsman"
            target="_blank"
            depressed
            rounded
            class="
              primary--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-8
            "
            :class="{ 'ml-2': informationsContacts.emergency_tel }"
          >
            <v-icon size="20"> far fa-comment-dots </v-icon>
            <span v-if="!xs" class="ml-2">Ouvidoria</span>
          </v-btn> -->

        <!-- <div class="d-flex">
          <v-btn
            color="transparent"
            href="https://exames.hospitaldoispinheiros.com.br:8443/Mediweb/login"
            target="_blank"
            depressed
            rounded
            class="
              white--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-8
            "
          >
            <span>Trabalhe Conosco</span>
          </v-btn>

          <v-btn
            color="transparent"
            href="https://exames.hospitaldoispinheiros.com.br:8443/Mediweb/login"
            target="_blank"
            depressed
            rounded
            class="
              white--text
              text-body-1 text-none
              font-weight-bold
              px-md-7 px-lg-8
            "
          >
            <v-icon size="20"> fa-stethoscope </v-icon>
            <span class="ml-2">Resultado de Exames</span>
          </v-btn>
        </div> -->
      </v-container>
    </v-sheet>
    <v-sheet height="64px">
      <v-app-bar flat color="white" class="main-header-mobile" height="64px">
        <div class="py-2 d-flex align-end">
          <router-link class="d-flex" to="/">
            <img
              v-if="informations.img"
              :src="files + informations.img"
              :alt="informations.name"
              class="d-block navbar-brand"
            />
          </router-link>
        </div>

        <v-spacer />

        <Search />
        <v-app-bar-nav-icon
          color="primary"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </v-app-bar>

      <v-navigation-drawer class="primary" v-model="drawer" fixed>
        <div class="px-8 py-6 d-flex flex-column">
          <router-link to="/" class="d-flex">
            <img
              v-if="informations.img"
              :src="files + informations.img"
              :alt="informations.name"
              class="mx-auto filter-white navbar-brand"
            />
          </router-link>
        </div>

        <v-list-item-group v-model="current">
          <v-list>
            <div v-for="({ text, to, submenu }, i) in menu" :key="i">
              <v-list-item v-if="!submenu" :to="to" link>
                <v-list-item-content>
                  <v-list-item-title class="white--text text-body-2 nav-link">
                    {{ text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group v-else no-action :value="false">
                <template v-slot:activator>
                  <v-list-item-title class="white--text text-body-2 nav-link">
                    {{ text }}
                  </v-list-item-title>
                </template>

                <v-list>
                  <v-list-item
                    class="pl-7"
                    v-for="({ text, to }, index) in submenu"
                    :key="index"
                    :to="to"
                    link
                  >
                    <v-list-item-content>
                      <v-list-item-title class="white--text text-body-2">
                        {{ text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-list-group>
            </div>
          </v-list>
        </v-list-item-group>

        <v-list-item-group style="margin-top: auto">
          <v-list>
            <v-list-item
              class="pl-7"
              v-if="informationsContacts.ombudsman"
              :href="informationsContacts.ombudsman"
            >
              <v-list-item-content>
                <v-list-item-title class="white--text text-body-2">
                  <v-icon size="20" color="white"> far fa-comment-dots </v-icon>
                  <span class="ml-2">Ouvidoria</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="pl-7"
              href="https://orcamentos.hospitaldoispinheiros.com.br/formularios/site-AttLT3/paciente"
              target="_blank"
            >
              <v-list-item-content>
                <v-list-item-title class="white--text text-body-2">
                  <v-icon size="20" color="white"> fas fa-user </v-icon>
                  <span class="ml-2">Solicitar Orçamentos</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="pl-7"
              href="https://wa.me/5566999940069"
              target="_blank"
            >
              <v-list-item-content>
                <v-list-item-title class="white--text text-body-2">
                  <v-icon size="20" color="white"> fas fa-user </v-icon>
                  <span class="ml-2">Trabalhe Conosco</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              class="pl-7"
              href="https://exames.hospitaldoispinheiros.com.br:8443/Mediweb/login"
              target="_blank"
            >
              <v-list-item-content>
                <v-list-item-title class="white--text text-body-2">
                  <v-icon size="20" color="white"> fa-stethoscope </v-icon>
                  <span class="ml-2">Resultado de Exames</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-group>
      </v-navigation-drawer>
    </v-sheet>
  </div>
</template>

<script>
import { getTelLinkFromPhone } from "../../../utils/getTelLinkFromPhone";
import Search from "../../widgets/Search.vue";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      if (!this.$rest("informations").item) return "";
      return this.$rest("informations").item;
    },
    informationsContacts() {
      return this.$rest("informations-contacts").item;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  components: {
    Search,
  },
};
</script>

<style>
.main-header-mobile {
  z-index: 610 !important;
}

.main-header-mobile .navbar-brand {
  height: 42px;
}

.v-navigation-drawer__content .navbar-brand {
  height: 70px;
}

.v-navigation-drawer {
  z-index: 9999999 !important;
}

.v-list-item__icon .v-icon {
  color: #ffffff !important;
  font-size: 14px !important;
}

.v-list-group .v-list-group__items {
  background-color: var(--v-primary-darken1) !important;
}

.v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
}
</style>
